import { DETERMINAR_PAGINA_ATUAL_VENDA } from '../types'

export default function determinarPaginaAtualVenda (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_VENDA,
    payload: paginaAtual
  }
}
